const MQ_REDUCED = '(prefers-reduced-motion: reduce)';
const CROSSFADE_MS = 900;
const NEAR_END_SEC = 1;
const DEFAULT_MIN_WIDTH = 768;

function parseSources(raw) {
    if (!raw) {
        return [];
    }
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed)
            ? parsed.filter(function (item) {
                return typeof item === 'string' && item.length > 0;
            })
            : [];
    } catch (e) {
        return [];
    }
}

function tryPlay(video) {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
    }
}

function clearVideo(video) {
    video.pause();
    video.removeAttribute('src');
    video.load();
}

function waitUntilReady(video) {
    return new Promise(function (resolve) {
        if (video.readyState >= 3) {
            resolve();
            return;
        }
        const done = function () {
            video.removeEventListener('canplay', done);
            video.removeEventListener('loadeddata', done);
            resolve();
        };
        video.addEventListener('canplay', done);
        video.addEventListener('loadeddata', done);
    });
}

function initHeroVideoPlaylist(root) {
    if (!root || root.dataset.heroVideoPlaylistInit) {
        return;
    }

    const sources = parseSources(root.getAttribute('data-sources'));
    if (sources.length === 0) {
        return;
    }

    const minWidth = parseInt(root.getAttribute('data-min-width') || String(DEFAULT_MIN_WIDTH), 10) || DEFAULT_MIN_WIDTH;
    if (!window.matchMedia('(min-width: ' + minWidth + 'px)').matches || window.matchMedia(MQ_REDUCED).matches) {
        return;
    }

    const videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    if (videos.length < 2) {
        return;
    }

    root.dataset.heroVideoPlaylistInit = '1';
    root.hidden = false;

    let index = 0;
    let active = 0;
    let transitioning = false;
    let nearEndArmed = false;
    let timeUpdateHandler = null;

    const getActive = function () {
        return videos[active];
    };

    const getIdle = function () {
        return videos[active === 0 ? 1 : 0];
    };

    const nextIndex = function () {
        return (index + 1) % sources.length;
    };

    const loadSource = function (video, src) {
        if (video.getAttribute('src') === src && video.readyState >= 2) {
            return waitUntilReady(video);
        }
        video.preload = 'auto';
        video.src = src;
        video.load();
        return waitUntilReady(video);
    };

    const detachNearEnd = function (video) {
        if (timeUpdateHandler) {
            video.removeEventListener('timeupdate', timeUpdateHandler);
            timeUpdateHandler = null;
        }
        nearEndArmed = false;
    };

    const prefetchNext = function () {
        const idle = getIdle();
        const src = sources[nextIndex()];
        loadSource(idle, src).catch(function () {});
    };

    const crossfadeToNext = function () {
        if (transitioning) {
            return;
        }

        const current = getActive();
        const next = getIdle();
        const src = sources[nextIndex()];

        transitioning = true;
        detachNearEnd(current);

        loadSource(next, src)
            .then(function () {
                next.currentTime = 0;
                tryPlay(next);
                next.classList.add('is-active');
                current.classList.remove('is-active');

                window.setTimeout(function () {
                    clearVideo(current);
                    active = active === 0 ? 1 : 0;
                    index = nextIndex();
                    transitioning = false;
                    attachNearEnd(getActive());
                    prefetchNext();
                }, CROSSFADE_MS);
            })
            .catch(function () {
                transitioning = false;
                tryPlay(current);
                attachNearEnd(current);
            });
    };

    const attachNearEnd = function (video) {
        detachNearEnd(video);

        timeUpdateHandler = function () {
            if (transitioning || nearEndArmed) {
                return;
            }
            const duration = video.duration;
            if (!duration || !isFinite(duration)) {
                return;
            }
            if (duration - video.currentTime <= NEAR_END_SEC) {
                nearEndArmed = true;
                crossfadeToNext();
            }
        };

        video.addEventListener('timeupdate', timeUpdateHandler);
        video.addEventListener(
            'ended',
            function onEnded() {
                if (!transitioning) {
                    crossfadeToNext();
                }
            },
            { once: true }
        );
    };

    const start = function () {
        const first = getActive();
        const second = getIdle();

        second.classList.remove('is-active');
        first.classList.remove('is-active');

        loadSource(first, sources[0]).then(function () {
            first.currentTime = 0;
            tryPlay(first);
            first.classList.add('is-active');
            attachNearEnd(first);
            prefetchNext();
        });
    };

    document.addEventListener('visibilitychange', function () {
        const video = getActive();
        if (document.hidden) {
            video.pause();
        } else if (root.dataset.heroVideoPlaylistInit) {
            tryPlay(video);
        }
    });

    start();
}

function bootHeroVideoPlaylists() {
    document
        .querySelectorAll('[data-home-hero-videos], [data-hero-video-playlist]')
        .forEach(initHeroVideoPlaylist);
}

document.addEventListener('DOMContentLoaded', bootHeroVideoPlaylists);
